/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ListItem } from "@microsoft/shifts-models-view";
import { ImgHTMLAttributes } from "react";

import { CardHeaderProps, CardProps } from "../../packages/fluent9";

import { SelectableListProps } from "./SelectableListProps";

/**
 * Gets the card header image properties for a selectable list item.
 * @param item The item.
 * @returns The card header image properties for a selectable list item.
 */
export const getCardHeaderImageProps = (item: ListItem): ImgHTMLAttributes<HTMLImageElement> | undefined => {
    if (item.icon) {
        return {
            src: item.icon.url
        };
    }
};

/**
 * Gets the card header properties for a selectable list item.
 * @param item The item.
 * @returns The card header properties for a selectable list item.
 */
export const getCardHeaderProps = (item: ListItem): CardHeaderProps => {
    return {
        header: item.label
    };
};

/**
 * Gets the card properties for a selectable list item.
 * @param props The selectable list properties.
 * @param item The item.
 * @returns The card properties for a selectable list item.
 */
export const getCardProps = (props: SelectableListProps, item: ListItem): CardProps => {
    const { onChange, selectedItem } = props;
    const { value } = item;
    const selected = selectedItem == value;

    const onSelectionChange: CardProps["onSelectionChange"] = (_event, { selected }): void => {
        onChange?.(selected ? value : undefined);
    };

    return {
        appearance: "subtle",
        onSelectionChange,
        selected
    };
};